import { useEffect, useState } from 'react';
import {
  Grid, Typography, Container
} from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import LoginForm from '../../components/auth/LoginForm';
import { login, loginRed } from '../../actions/auth';
import { isEmpty } from '../../components/common/helpers';

import { useDispatch, useSelector } from 'react-redux';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const errors = useSelector(state => state.auth.error);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);



  const [error, setError] = useState({
    email: '',
    password: ''
  });

  useEffect(() => {
    const email = errors?.find(info => info.param === 'email');
    const password = errors?.find(info => info.param === 'password');
    const err = {
      email: '',
      password: ''
    }
    if (!isEmpty(email)) {
      err.email = email.msg
    }
    if (!isEmpty(password)) {
      err.password = password.msg
    }
    setError({
      email: err.email,
      password: err.password
    })
  }, [errors]);

  const irA = where => e => {
    e.preventDefault();
    navigate(where);
  }

  const onSubmit = async (email, pass) => {
    await dispatch(login(email, pass));
  }

  const responseGoogle = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        localStorage.setItem('access_token', credentialResponse.access_token);
        // Usar el access_token para obtener los datos del usuario
        const userInfo = await axios.get(
          'https://www.googleapis.com/oauth2/v1/userinfo?alt=json',
          {
            headers: {
              Authorization: `Bearer ${credentialResponse.access_token}`,
              Accept: 'application/json',
            },
          }
        );
        const data = {
          email: userInfo.data.email,
          name: userInfo.data.given_name,
          apellido: userInfo.data.family_name,
        };
        // Llama a tu función de login con los datos
        dispatch(loginRed(data));
      } catch (error) {
        console.error('Error fetching user info:', error);
      }

    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  //Redirect
  if (isAuthenticated) {
    return <Navigate to="/home" />
  }

  const responseFacebook = response => {
    const data = {
      userId: response.id,
      email: response.email,
      name: response.first_name,
      apellido: response.last_name
    }
    //dispatch(loginRed(data));
  }

  return (
    <Container
      sx={{
        flex: 1, // Ocupa el espacio disponible entre el header y el footer
        display: 'flex',
        alignItems: { xs: 'flex-start', md: 'center' }, // Center vertically on md+, start on mobile
        justifyContent: 'center',
      }}
    >
      <Grid container spacing={3}
        sx={{
          maxWidth: 'lg',
          flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile, row on md+
          alignItems: { xs: 'center', md: 'center' }, // Center items
          justifyContent: 'center',
        }}>
        <Grid className="logo-login" size={6} item>
          <img width="400" src="/logo-os-24.svg" alt="OneService" />
          <Typography variant='h3' color="primary" mt={3}>
            "Encuentra y ofrece servicios en un solo lugar."
          </Typography>
        </Grid>
        { /*Formulario de login */}
        <LoginForm
          onSubmit={onSubmit}
          google={responseGoogle}
          facebook={responseFacebook}
          irA={irA}
          error={error}
        />
      </Grid>
    </Container>
  );
}

export default Login;